import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
// components
import AccountPayable from '../../../../components/modules/report/account-payable';
import AccountPayableMiddleware from '../../../../middleware/modules/report/account-payable';
import { Helmet } from 'react-helmet';
import i18n from '../../../../i18n';
// middlewares
 

const mapStateToProps = ({ auth,accountPayable }) => ({
  isProcessing: accountPayable.isProcessing,
  isError: accountPayable.isError,
  errorMessage: accountPayable.errorMessage,
  datalist:accountPayable.data,
  showModal:accountPayable.showModal,
  helperList:accountPayable.helperAccountPayable
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    getHelper:()=>AccountPayableMiddleware.getHelper(),
    reset: () =>AccountPayableMiddleware.resetList(),
    // search: data =>AccountPayableMiddleware.list(data),
    setData: (data) =>AccountPayableMiddleware.list(data),
    excel: (data) =>AccountPayableMiddleware.showExcel(data),
  }, dispatch);
};
class AccountPayableContainer extends Component {
  
  static propTypes = {
    isAuthenticated: PropTypes.bool,
    isProcessing: PropTypes.bool,
    isRegistered: PropTypes.bool,
    isError: PropTypes.bool,
    errorMessage: PropTypes.any,
    datalist: PropTypes.any,
    // search: PropTypes.func.isRequired
  }

  static defaultProps = {
    isAuthenticated: false,
    isProcessing: false,
    isRegistered: false,
    isError: false,
    errorMessage: [],
  }

  constructor(props){
    super(props)
  }

  submitItem() {
    this.props.setData();
  }

  componentWillMount() {
    const search = {
      limit: 10,
    };
    this.props.reset();
    this.props.getHelper()
    // this.props.search(search);
  
  }

  render() {
    const {datalist} = this.props;
    return (
      <React.Fragment>
        <Helmet>
          <title>
            {i18n.t("Account Payable List")}
          </title>
        </Helmet>
      <AccountPayable
        {...this.props}
        data={datalist}
      />
      </React.Fragment>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AccountPayableContainer);
